/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { ImageEventType } from 'app/shared/model/enumerations/image-event-type.model';
import { ImageStatus } from 'app/shared/model/enumerations/image-status.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './event-image.reducer';

export const EventImageUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const eventImageEntity = useAppSelector(state => state.eventImage.entity);
  const loading = useAppSelector(state => state.eventImage.loading);
  const updating = useAppSelector(state => state.eventImage.updating);
  const updateSuccess = useAppSelector(state => state.eventImage.updateSuccess);
  const imageEventTypeValues = Object.keys(ImageEventType);
  const imageStatusValues = Object.keys(ImageStatus);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/event-image${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.sortOrder !== undefined && typeof values.sortOrder !== 'number') {
      values.sortOrder = Number(values.sortOrder);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...eventImageEntity,
      ...values,
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          eventType: 'APPOINTMENT',
          status: 'BEFORE_APPOINTMENT',
          addedByType: 'DOCTOR',
          modifiedByType: 'DOCTOR',
          ...eventImageEntity,
          patient: eventImageEntity?.patient?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.eventImage.home.createOrEditLabel" data-cy="EventImageCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.eventImage.home.createOrEditLabel">Create or edit a EventImage</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="event-image-id"
                  label={translate('tinyMedicRestApp.eventImage.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.eventId')}
                id="event-image-eventId"
                name="eventId"
                data-cy="eventId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.eventType')}
                id="event-image-eventType"
                name="eventType"
                data-cy="eventType"
                type="select"
              >
                {imageEventTypeValues.map(imageEventType => (
                  <option value={imageEventType} key={imageEventType}>
                    {translate(`tinyMedicRestApp.ImageEventType.${imageEventType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.mediaName')}
                id="event-image-mediaName"
                name="mediaName"
                data-cy="mediaName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.originalFilePath')}
                id="event-image-originalFilePath"
                name="originalFilePath"
                data-cy="originalFilePath"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.originalFileName')}
                id="event-image-originalFileName"
                name="originalFileName"
                data-cy="originalFileName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.message')}
                id="event-image-message"
                name="message"
                data-cy="message"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.mimeType')}
                id="event-image-mimeType"
                name="mimeType"
                data-cy="mimeType"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.sortOrder')}
                id="event-image-sortOrder"
                name="sortOrder"
                data-cy="sortOrder"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.status')}
                id="event-image-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {imageStatusValues.map(imageStatus => (
                  <option value={imageStatus} key={imageStatus}>
                    {translate(`tinyMedicRestApp.ImageStatus.${imageStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.addedById')}
                id="event-image-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.addedByType')}
                id="event-image-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.modifiedByID')}
                id="event-image-modifiedByID"
                name="modifiedByID"
                data-cy="modifiedByID"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.modifiedByType')}
                id="event-image-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.active')}
                id="event-image-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.cursor')}
                id="event-image-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.lastupdated')}
                id="event-image-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.microSec')}
                id="event-image-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.eventImage.timestampentry')}
                id="event-image-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="event-image-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.eventImage.patient')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/event-image" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EventImageUpdate;
